export default "__VITE_ASSET__CYNh3bNs__"